var render = function render(){var _vm=this,_c=_vm._self._c;return _c('air-verification-code',{attrs:{"placeholder":_vm.placeholder,"size":_vm.size,"maxLength":_vm.maxLength,"actionText":_vm.actionText,"sendCode":_vm.onSendCode,"handlerErrorBySelf":_vm.handlerErrorBySelf},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }